/*
 *  Author: DL
 *  Date: 2020-12-15 12:04:37
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-21 12:17:46
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

(function() {
    //百度语音合成Token，具体获取请查询百度语音合成相关资料 https://ai.baidu.com/docs#/Auth/top
    var TOKEN = '25.7b80570da925b348fc6615ac0517083c.315360000.1931142241.282335-23708463';
    var element;

    function tts(text, volume = true) {
        if (!window.device) return;
        if (!text) text = '';
        text = text.replace(/undefined/g, ''); //去掉undiefined的文字
        var os = window.device.os;

        if (element) {
            element.pause();
            element = null;
        }
        if (os === 'ios') {
            window.speechSynthesis.cancel();
        }

        //当系统是ios的时候使用HTML5 speechSynthesisAPI合成语音，否则使用百度语音合成API
        if (os === 'ios') {
            window.speechSynthesis.cancel();
            var utterThis = new window.SpeechSynthesisUtterance(text);
            utterThis.volume = volume ? 20 : 0; //音量0到1，默认值1
            utterThis.rate = 1; //语速，范围是0.1到10，如果值是2，则是正常声音的2倍
            utterThis.pitch = 1; //表示说话的音高，数值，范围从0（最小）到2（最大）。默认值为1
            window.speechSynthesis.speak(utterThis);
        } else {
            // 参数含义请参考 https://ai.baidu.com/docs#/TTS-API/41ac79a6
            window.btts(
                {
                    tex: text,
                    tok: TOKEN,
                    spd: 5, //速度，取值0-15，默认为5中语速
                    pit: 5, //音调，取值0-15，默认为5中语调
                    vol: 15, //音量，取值0-15，默认为5中音量
                    per: 0, //发音, 0为普通女声，1为普通男生，3为情感合成-度逍遥，4为情感合成-度丫丫，默认为普通女声
                    aue: 3, //3为mp3格式(默认)； 4为pcm-16k；5为pcm-8k；6为wav（内容同pcm-16k）; 注意aue=4或者6是语音识别要求的格式，但是音频内容不是语音识别要求的自然人发音，所以识别效果会受影响。
                    ctp: 1,
                },
                {
                    volume: volume ? 0.3 : 0,
                    autoDestory: true,
                    timeout: 10000,
                    hidden: true,
                    onInit: function(htmlAudioElement) {},
                    onSuccess: function(htmlAudioElement, e) {
                        if (element) {
                            element.pause();
                            element = null;
                        }
                        element = htmlAudioElement;
                        htmlAudioElement.style.display = 'block';
                        htmlAudioElement.play();
                    },
                    onError: function(error) {
                        //console.log('error', error);
                    },
                    onTimeout: function(error) {
                        //console.log('timeout', error);
                    },
                },
            );
        }
    }

    window['tts'] = tts;
})();
